import React from 'react';
function VTXCart (props){
	return (
		<p>cart</p>
	);
}

export default VTXCart;